import IntroDogIllustration from '@/assets/images/intro-dog-illu.svg';
import Button from '@petplate/ui/components/Button';
import lens from '@refract-ui/sc/lens';
import { css } from 'styled-components';

export const Container = lens.div({ pb: 6 })`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  position: relative;
`;

export const Header = lens.div()`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = lens.h3({ mt: 8, mb: 4 })`
  text-align: center;
`;

export const Illustration = lens({ mt: 4 })(IntroDogIllustration)`
  ${({ theme: { mq } }) => css`
    width: auto;
    max-height: 200px;

    ${mq.md`
      max-height: 230px;
    `}

    ${mq.lg`
      max-height: 250px;
    `}

    ${mq.xl`
      max-height: 260px;
    `}
  `}
`;

export const Description = lens.span({ t: ['bodyMd', { sm: 'bodyLg' }] })`
  text-align: center;
`;

export const InfoBlocksContainer = lens.div()`
  ${({ theme: { mq } }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1.5rem;
    margin: 2.75rem auto 0;

    ${mq.sm`
      flex-direction: column;
    `}

    ${mq.md`
      flex-direction: row;
      align-items: center;
    `}
  `}
`;

export const InfoBlock = lens.div()`
  ${({ theme: { mq } }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    svg {
      width: 32px;
      height: 32px;
    }

    ${mq.sm`
      svg {
        width: 56px;
        height: 56px;
      }
    `}

    ${mq.md`
      flex-direction: column;
      max-width: 200px;
    `}
  `}
`;

export const InfoText = lens.span({ t: ['bodyMd', { sm: 'bodyLg' }] })`
  ${({ theme: { mq } }) => css`
    ${mq.md`
      text-align: center;
    `}
  `}
`;

export const IntroFooter = lens.div({
  pv: 4,
  ph: [6, { md: 4 }],
  bg: 'light'
})`
  width: 100%;
  display: flex;
  justify-content: center;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  box-shadow: 0px -1px 6px 0px rgba(0, 0, 0, 0.15);
`;

export const GetStartedButton = lens()(Button)`
  min-width: 16.25rem;
`;
